<template>
  <div>
    <button
      type="button"
      :data-bs-target="dataBsTarget"
      :data-bs-slide="dataBsSlide"
      class="bg-transparent fs-3 border-0 font-color-grey"
      :disabled="numSlides === 1"
      @click="$emit('clicked')">
      <font-awesome-icon icon="circle-arrow-right" />
    </button>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

// Define props in a class
class ButtonArrowCarouselNextProps {
  dataBsTarget = prop({
    // Same as Vue core's prop option
    type: String,
    required: true
  })
  dataBsSlide = prop({
    // Same as Vue core's prop option
    type: String,
    required: true
  })
  numSlides = prop({
    // Same as Vue core's prop option
    type: Number,
    required: true
  })
}

@Options({
  components: {
  }
})
export default class ButtonArrowCarouselNext extends Vue.with(ButtonArrowCarouselNextProps) {
}
</script>

<style lang="stylus">
</style>
